import request from "../api";

// 获取微信token
export function getWxToken(data) {
  return request({
    url: "/standalone/draw/auth/access-token",
    method: "get",
    params: data,
  });
}
// 获取试题列表
export function getRandomQuestion(data) {
  return request({
    url: "/standalone/draw/getRandomQuestion",
    method: "get",
    params: data,
  });
}
// 获取签名等
export function authSign(data) {
  return request({
    url: "/standalone/draw/auth/sign",
    method: "get",
    params: data,
  });
}

// 保存
export function checkAnswer(data) {
  return request({
    url: "/standalone/draw/checkAnswer",
    method: "post",
    data: data,
  });
}

// 收钱
export function redPacket(data) {
  return request({
    url: "/standalone/draw/send/redPacket",
    method: "post",
    data: data,
  });
}
